import {
  FilterLiveForm,
  InfiniteListBase,
  useListContext,
  useTranslate,
} from "ra-core";
import { Link } from "react-router";
import { SearchInput } from "@/components/admin/search-input";

import { CompanyAvatar } from "../companies/CompanyAvatar";
import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { InfinitePagination } from "../misc/InfinitePagination";
import type { Company } from "../types";

// Sur téléphone : liste des sociétés avec recherche, sans les filtres du CRM (taille, secteur).
export const CompanyListMobile = () => (
  <InfiniteListBase perPage={25} sort={{ field: "name", order: "ASC" }}>
    <MobileHeader>
      <FilterLiveForm formComponent={FlexForm}>
        <SearchInput source="q" />
      </FilterLiveForm>
    </MobileHeader>
    <MobileContent>
      <CompanyRows />
      <div className="flex justify-center">
        <InfinitePagination />
      </div>
    </MobileContent>
  </InfiniteListBase>
);

const FlexForm = (props: React.FormHTMLAttributes<HTMLFormElement>) => (
  <form className="flex-1" {...props} />
);

const CompanyRows = () => {
  const translate = useTranslate();
  const { data, isPending } = useListContext<Company>();
  if (isPending) return null;
  if (!data?.length) {
    return (
      <p className="text-sm text-muted-foreground py-8 text-center">
        {translate("resources.companies.empty.title")}
      </p>
    );
  }
  return (
    <div className="flex flex-col">
      {data.map((record) => (
        <Link
          key={record.id}
          to={`/companies/${record.id}/show`}
          className="flex items-center gap-3 py-2.5 active:bg-muted"
        >
          <CompanyAvatar record={record} />
          <div className="min-w-0 flex-1">
            <div className="font-medium leading-snug line-clamp-2">
              {record.name}
            </div>
            <div className="text-sm text-muted-foreground truncate">
              {[record.sector, record.city, record.country]
                .filter(Boolean)
                .join(" · ")}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};
